import { render, staticRenderFns } from "./GridCampaigns.vue?vue&type=template&id=a8a8725a&scoped=true&"
import script from "./GridCampaigns.vue?vue&type=script&lang=js&"
export * from "./GridCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./GridCampaigns.vue?vue&type=style&index=0&id=a8a8725a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a8725a",
  null
  
)

export default component.exports